'use strict';

var React = require('react');

var SvgMoneyMinor = function SvgMoneyMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 4.5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-14Zm7 8.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
  }));
};

exports.SvgMoneyMinor = SvgMoneyMinor;
